import { changeLuminosity, crops, getCropColor, getCropCssColor, getWhiteBlackForegroundFromBackgroundColor, ICrop, ISeedStock, IVariety, StockType } from "../omnia";
import { StockVm } from "./stockVm";


export class SeedStockVm extends StockVm {

    constructor(private seed: ISeedStock) {
        super(seed, StockType.Seed);
    }

    get icon(): string {
        return "stock-seed";
    }

    hasProduct(): boolean {
        return true;
    }

    getUnits() {
        return "kg";
    }

    getImgUrl(): string {
        return "/images/stocks/Sack.svg";
    }

    getColor(): number[] {

        var color = getCropColor(this.crop);

        var tooDark = getWhiteBlackForegroundFromBackgroundColor(color);

        if (tooDark) {
            color = changeLuminosity(color, 1.4);
        } else {
            color = changeLuminosity(color, 0.6);
        }

        return color;
    }

    get orderByDescription(): string {
        return this.crop.Name + (this.variety ? this.variety.Name : "") + this.stock.Name;
    }

    getTooltip(): string {
        return this.variety ? this.variety.Name : this.crop.Name
    }

    getRequiredAmount(): number {
        return crops.convertThousandSeedsToKg(this.stock.ReqdAmount, this.seed.TGW);
    }

    get crop(): ICrop {
        return this.seed.Crop;
    }

    get variety(): IVariety {
        return this.seed.Variety;
    }

    getCropColor() {
        return getCropCssColor(this.crop);
    }

    get germinationRate(): number {
        return this.seed.GerminationRate;
    }

    get tgw(): number {
        return this.seed.TGW;
    }

}
